/** The keys a caller needs to run `authz`, with the listed arguments sent. */
export function requiredKeysFor(authz, withArguments = []) {
    var _a;
    var _b;
    const keys = new Set('requires' in authz ? authz.requires : []);
    for (const argument of withArguments) {
        for (const key of (_b = (_a = authz.argumentRequires) === null || _a === void 0 ? void 0 : _a[argument]) !== null && _b !== void 0 ? _b : [])
            keys.add(key);
    }
    return [...keys];
}
//# sourceMappingURL=operationAuthz.js.map